/**
 * 404 Not Found page
 */
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';
import { useLanguage } from '@/store';
import { getNotFoundTranslation } from '@/utils';

export function NotFoundPage() {
  const language = useLanguage();

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center py-12 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-muted-foreground/20">404</h1>
        <h2 className="text-2xl font-bold mt-4">
          {getNotFoundTranslation('pageTitle', language)}
        </h2>
        <p className="text-muted-foreground mt-2 max-w-md mx-auto">
          {getNotFoundTranslation('pageDesc', language)}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Button asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              {getNotFoundTranslation('goHome', language)}
            </Link>
          </Button>
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            {getNotFoundTranslation('goBack', language)}
          </Button>
        </div>
      </div>
    </div>
  );
}
